import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const LibraryMobileIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M17 0.25H7C5.48 0.25 4.25 1.48 4.25 3V21C4.25 22.52 5.48 23.75 7 23.75H17C18.52 23.75 19.75 22.52 19.75 21V3C19.75 1.48 18.52 0.25 17 0.25ZM18.25 21C18.25 21.69 17.69 22.25 17 22.25H7C6.31 22.25 5.75 21.69 5.75 21V3C5.75 2.31 6.31 1.75 7 1.75H17C17.69 1.75 18.25 2.31 18.25 3V21Z"
        fill={color}
      />
      <path
        d="M12.51 18.75H11.5C11.1576 18.75 10.88 19.0276 10.88 19.37V20.38C10.88 20.7224 11.1576 21 11.5 21H12.51C12.8524 21 13.13 20.7224 13.13 20.38V19.37C13.13 19.0276 12.8524 18.75 12.51 18.75Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

LibraryMobileIcon.displayName = 'LibraryMobileIcon';
